module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }